module.exports = __webpack_public_path__ + "static/atable-2052105770f8975c510b6bb8d1a9a379.png";